import { Campfire } from './Campfire';
import './ui.css';

// Wake and Sleep, as the server cards show them. Both name the server for screen readers, as a
// page holds several. They only ask: the caller confirms (ConfirmDialog) before acting.

/** Wake: the lit campfire alone, no box; brighter and swaying on hover. */
export function WakeButton({ serverName, onClick }: { serverName: string; onClick: () => void }) {
  return (
    <button className="wake" type="button" aria-label={`Wake ${serverName}`} title="Wake" onClick={onClick}>
      <Campfire state="lit" height={30} still />
    </button>
  );
}

/** Sleep: moonlight, with a moon. */
export function SleepButton({ serverName, onClick }: { serverName: string; onClick: () => void }) {
  return (
    <button className="btn btn-moon btn-tall" type="button" aria-label={`Sleep ${serverName}`} onClick={onClick}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
        <path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z" />
      </svg>
      Sleep
    </button>
  );
}
